<template>
  <div>
    <link-button class="text-medium" @click="showModal = true">
      <div class="d-flex align-items-center">
        <i class="stars-greyed-icon mr-1"></i>
        AI Initiatives
      </div>
    </link-button>
    <a-i-initiatives-modal
      @initiatives-created="$emit('initiatives-created')"
      :kr="kr"
      v-model="showModal"
      v-if="showModal"
    />
  </div>
</template>

<script>
import LinkButton from '@/components/buttons/LinkButton.vue'
import AIInitiativesModal from '@/components/initiative/aiInitiatives/AIInitiativesModal.vue'

/**
 * This provides a link to generate initiatives via AI
 * It gives a button, click of which open a modal where AI generated initiatives are shown.
 */
export default {
  name: 'AddAIInitiativesLink',
  props: ['kr'],
  components: { AIInitiativesModal, LinkButton },
  data() {
    return {
      showModal: false
    }
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
